import { classes } from 'html-classes';
import React from 'react';

import styles from './Checkbox.module.scss';

export interface CheckboxProps {
  label: string | React.ReactNode;
  value: string | number;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  name?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  value,
  checked,
  onChange,
  className,
  labelClassName,
  disabled = false,
  name,
}) => {
  return (
    <label
      className={classes([
        styles.checkbox,
        className,
        disabled && styles.disabled,
      ])}
    >
      <input
        type="checkbox"
        checked={checked}
        value={value}
        className={styles.input}
        onChange={onChange}
        disabled={disabled}
        name={name}
      />
      <span className={styles.mark} />
      <span className={classes([styles.label, labelClassName])}>{label}</span>
    </label>
  );
};
